'use client';

import { ExternalLinkIcon } from '@/components/primitives/icons/ExternalLinkIcon';
import { trackOutboundClick } from '@/lib/analytics/trackEvent';

import styles from './OutboundTextLink.module.css';

import type { GaLinkPlacement } from '@/constants/analytics';
import type { ReactNode } from 'react';

type OutboundTextLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  /** When set, fires labelled `outbound_click` on activate. */
  linkPlacement?: GaLinkPlacement;
};

/**
 * Underlined text link with the Figma outbound-link icon (16px, 8px gap).
 * Colour / type come from the caller’s `className` (chapter link styles).
 */
export function OutboundTextLink({
  href,
  children,
  className,
  linkPlacement,
}: OutboundTextLinkProps) {
  const classes = className ? `${styles.root} ${className}` : styles.root;

  return (
    <a
      href={href}
      className={classes}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        if (!linkPlacement) return;
        trackOutboundClick({ href, linkPlacement });
      }}
    >
      <ExternalLinkIcon className={styles.icon} />
      <span className={styles.label}>{children}</span>
    </a>
  );
}
